const modal = document.querySelector("[data-501-modal]");
const button = document.querySelector("[data-501-button]");
const closeBtn = document.querySelector("[data-501-close]");
export function setupModal() {
	button.addEventListener("click", openModal);
	closeBtn.addEventListener("click", closeModal);
	window.onclick = (e) => {
		if (e.target == modal) {
			modal.style.display = "none";
		}
	};
}

function openModal() {
	modal.style.display = "block";
}
function closeModal() {
	modal.style.display = "none";
}

setupModal();
